import { z } from 'zod';
import { PredictionStatusSchema } from '@/entities/prediction';

export const ReplicateUrlsSchema = z.object({
  get: z.string().url(),
  cancel: z.string().url().optional(),
  stream: z.string().url().optional(),
});

export const ReplicateMetricsSchema = z
  .object({
    predict_time: z.number().optional(),
    total_time: z.number().optional(),
    input_token_count: z.number().optional(),
    output_token_count: z.number().optional(),
  })
  .partial();

export const ReplicatePredictionSchema = z.object({
  id: z.string(),
  model: z.string().optional(),
  version: z.string().optional(),
  input: z.unknown().optional(),
  status: PredictionStatusSchema,
  output: z.unknown().nullable().optional(),
  error: z.union([z.string(), z.record(z.unknown())]).nullable().optional(),
  logs: z.string().nullable().optional(),
  created_at: z.string().optional(),
  started_at: z.string().nullable().optional(),
  completed_at: z.string().nullable().optional(),
  metrics: ReplicateMetricsSchema.optional(),
  urls: ReplicateUrlsSchema.optional(),
});
export type ReplicatePrediction = z.infer<typeof ReplicatePredictionSchema>;

export const ReplicateFileSchema = z.object({
  id: z.string(),
  urls: z.object({ get: z.string().url() }),
});
export type ReplicateFile = z.infer<typeof ReplicateFileSchema>;
